import fetchHandler, { fetchHandlerForm } from './Handler';

export const createOrder = async (data: FormData): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: 'order',
			data,
		});
		if (response) {
			return response;
		}
	} catch (error) {
		console.error('errror showing', error);
		throw error;
	}
};

export const getAllOrder = async (): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: 'admin/order', // Corrected endpoint
		});
		return response;
	} catch (error) {
		console.error('Error fetching orders:', error); // Corrected error message
		throw new Error('Could not fetch orders. Please try again later.'); // Corrected error message
	}
};

export const deleteOrder = async (data: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'DELETE',
			endpoint: `order/${data}`, // Corrected endpoint
		});
		return response;
	} catch (error) {
		console.error('Error deleting order:', error); // Corrected error message
		throw new Error('Could not delete order. Please try again later.'); // Corrected error message
	}
};

// =======================================================
export const updateOrder = async (body: FormData, id: string): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `admin/order/${id}`,
			body,
		});
		return response;
	} catch (error) {
		console.error('Error updating order:', error); // Corrected error message
		throw new Error('Could not update order. Please try again later.'); // Corrected error message
	}
};

export const updateOrderStatus = async (data: any, id: string): Promise<any> => {
	try {
		const response = await fetchHandlerForm({
			method: 'PATCH',
			endpoint: `order/${id}`,
			body: data,
		});
		return response;
	} catch (error) {
		console.error('Error updating order status:', error); // Corrected error message
		throw new Error('Could not update order status. Please try again later.'); // Corrected error message
	}
};

export const getSingleCategory = async (id: string): Promise<any> => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `order/${id}`,
		});
		return response;
	} catch (error) {
		console.error('Error fetching order:', error); // Corrected error message
		throw new Error('Could not fetch order. Please try again later.'); // Corrected error message
	}
};
